import { ECountry } from '@portals/help-center-core';

export const UTM_PREFIX = 'utm';

export const FOOTER_CONTROLS_COUNTRIES: Array<ECountry> = [
  ECountry.RUSSIA,
  ECountry.ARMENIA,
  ECountry.BELARUS,
  ECountry.KYRGYZSTAN,
  ECountry.KAZAKHSTAN,
  ECountry.UZBEKISTAN,
  ECountry.TAJIKISTAN,
];

export enum ANALYTIC_AB_GROUP {
  B_GROUP = 'test',
  A_GROUP = 'control',
  DISABLED = '',
}
